// Card #1797 — the Blank mode type's logo source is a COMMITTED BRAND
// ASSET, not `Show.logoKey` (#1058)'s S3 upload path and not view/show/org
// config (design decision on the card, superseding this repo's earlier
// working assumption in packages/brand/venues/README.md that #1797 would
// wire up to logoKey — it does not).
//
// Card #2308 (bug #211) — the original version of this file resolved a
// mode's `logoAsset` through a small HARDCODED key->image map
// (`BLANK_LOGO_ASSETS`), which is exactly how "WEC (vertical, white)" ended
// up offered to every org regardless of who they are. That map, and the
// venue-asset import it needed, are gone. `mode.logoAsset` is now the id of
// one of the SIGNED-IN ORG's own uploaded brand assets (ModeEditorDialog.jsx
// / score-api's BRAND_ASSET table); score-api's public scoreboard route
// resolves that id into a real (presigned, org-scoped) URL server-side —
// scoreboard-public.js's `resolveBlankLogoAssetUrl`, tenant-interlocked on
// orgId — and hands it down as `mode.logoAssetUrl`. This file's only job is
// now the FINAL fallback step: an unset/failed-to-resolve URL (deleted
// asset, wrong org, never picked) always falls back to the Fox Village
// default, so the board is never left with nothing to show (#1798: "NEVER
// show an error message on the scoreboard" — an empty board reads exactly
// like a dead projector). score-fe has no org context on this public,
// unauthenticated route to do its own id->URL lookup even if it wanted to —
// resolving server-side is not just cleaner, it is the only place this can
// be checked safely.
//
// 🔴 The default is the Fox Village FOX MARK, not the favicon. This card
// originally used packages/brand/favicon/favicon.svg on the reasoning that
// it was the only SQUARE Fox Village artwork (FoxVillageLogo.jsx being a
// 219x332 portrait mark, report-defs' LOGO_WIDE_SVG a 1201x333 lockup).
// That reasoning was wrong twice over. Jaybill, 2026-08-20: the favicon is
// "vestigial and NOT correct" — blown up to this view's centrepiece scale it
// reads as a box/crate, not a brand mark, which is exactly what #1798's
// universal fallback must not look like. And "square" was never a real
// constraint: a portrait mark centred in a centred flex box is fine.
//
// packages/brand/logo/fox-village-mark-white.svg is the SAME artwork as
// brand's FoxVillageLogo.jsx (identical viewBox 0 0 219.26 332), committed
// as a standalone file with its fill hardcoded white rather than imported as
// that JSX component, because resolveBlankLogoAsset's contract is a plain
// <img> src STRING (pinned by blankLogoAssets.test.js). White is correct
// unconditionally: the board is always dark (Jaybill, 2026-08-20), which is
// also why this file no longer reasons about theme background at all.
import foxVillageMark from "brand/logo/fox-village-mark-white.svg";

// Resolves a mode's (server-resolved) `logoAssetUrl` to an image src. Never
// throws: a falsy/empty/non-string value simply falls through to the
// default via `||`, same contract this function has always had — the only
// thing that changed under card #2308 is that the input is now a resolved
// URL rather than a hardcoded key, so there is no lookup left to do.
export function resolveBlankLogoAsset(logoAssetUrl) {
  return logoAssetUrl || foxVillageMark;
}
